class BabyCalculator extends HTMLElement {
  connectedCallback() {
    // ================= AGE =================
    this.ageMode = this.querySelector('[data-age-mode]');
    this.ageInput = this.querySelector('[data-age-single]');
    this.ageResult = this.querySelector('[data-age-result]');
    this.ageInWeeks = null;
    this.form = this.querySelector('form');

    // ================= WEIGHT =================
    this.weightMode = this.querySelector('[data-weight-mode]');
    this.weightInput = this.querySelector('[data-weight-single]');
    this.weightResult = this.querySelector('[data-weight-result]');
    this.weightInKg = null;

    this.ageSelectLabel = this.querySelector('[data-age-mode-label]');
    this.weightSelectLabel = this.querySelector('[data-weight-mode-label]');

    this.initAgeData();
    this.initWeightData();

    this.ageMode.addEventListener('change', () => {
      this.switchAgeMode();
      this.updateAgeSelectLabel();
    });

    this.weightMode.addEventListener('change', () => {
      this.switchWeightMode();
      this.updateWeightSelectLabel();
    });

    // this.ageInput.addEventListener('input', () => this.handleAgeInput());
    // this.weightInput.addEventListener('input', () => this.handleWeightInput());

    // this.clearBtn = this.querySelector('.baby-calculator__clear-changes-btn');
    // if (this.clearBtn) {
    //   this.clearBtn.addEventListener('click', () => this.clearAll());
    // }

    if (this.form) {
      this.form.addEventListener('submit', e => {
        e.preventDefault();
        this.handleAgeInput()
        this.handleWeightInput()

        window.LOQ = window.LOQ || [];
        window.LOQ.push(['ready', async (LO) => {
          try {
            await LO.$internal.ready('events');
            LO.events.track('Diaper Calculator Interaction');
            console.log('[Lucky Orange] Event tracked successfully!');
          } catch (error) {
            console.error('[Lucky Orange Error]', error);
          }
        }]);
      });
    }

    // this.initSaveInputs();

    this.updateAgeSelectLabel();
    this.updateWeightSelectLabel();
  }

  // ================= AGE DATA =================
  initAgeData() {
    const raw = JSON.parse(
      this.querySelector('[data-age-response]')?.textContent || '[]'
    );

    this.ageMap = new Map();
    this.ageWeeks = [];

    raw.forEach(item => {
      const week = parseInt(item["AGE (Weeks)"], 10);
      if (!isNaN(week)) {
        this.ageMap.set(week, item.RESPONSE);
        this.ageWeeks.push(week);
      }
    });

    this.ageWeeks.sort((a, b) => a - b);
  }

  // ================= AGE =================
  handleAgeInput() {
    const val = parseFloat(this.ageInput.value);

    if (!this.ageInput.value || isNaN(val)) {
      this.ageInWeeks = null;
      this.ageResult.textContent = '';
      return;
    }

    this.ageInWeeks =
      this.ageMode.value === 'months'
        ? val * 4.345
        : val;

    this.calculateAge();
  }

  switchAgeMode() {
    if (this.ageInWeeks == null) return;

    const display =
      this.ageMode.value === 'months'
        ? this.ageInWeeks / 4.345
        : this.ageInWeeks;

    this.ageInput.value = this.round(display);
    this.calculateAge();
  }

  calculateAge() {
    if (this.ageInWeeks == null || !this.ageWeeks.length) {
      this.ageResult.textContent = '';
      return;
    }

    const target = Math.round(this.ageInWeeks);

    const min = this.ageWeeks[0];
    const max = this.ageWeeks.at(-1);

    if (target < min || target > max) {
      const minMonths = min / 4.345;
      const maxMonths = max / 4.345;

      this.ageResult.textContent =
        this.ageMode.value === 'months'
          ? `Age must be between ${minMonths.toFixed(1)} and ${maxMonths.toFixed(1)} months`
          : `Age must be between ${min} and ${max} weeks`;

      return;
    }

    const closest = this.findClosest(this.ageWeeks, target);
    const response = this.ageMap.get(closest);

    this.ageResult.innerHTML = this.formatText(response || '');
  }

  // ================= WEIGHT =================
  initWeightData() {
    const raw = JSON.parse(
      this.querySelector('[data-weight-response]')?.textContent || '[]'
    );

    this.weightMap = new Map();
    this.weightLbs = [];

    raw.forEach(item => {
      const lb = parseInt(item["WEIGHT (lb)"], 10);
      if (!isNaN(lb)) {
        this.weightMap.set(lb, item.RESPONSE);
        this.weightLbs.push(lb);
      }
    });

    this.weightLbs.sort((a, b) => a - b);
  }

  handleWeightInput() {
    const val = parseFloat(this.weightInput.value);

    if (!this.weightInput.value || isNaN(val)) {
      this.weightInKg = null;
      this.weightResult.textContent = '';
      return;
    }

    this.weightInKg =
      this.weightMode.value === 'kg'
        ? val
        : val * 0.453592;

    this.calculateWeight();
  }

  switchWeightMode() {
    if (this.weightInKg == null) return;

    const display =
      this.weightMode.value === 'kg'
        ? this.weightInKg
        : this.weightInKg / 0.453592;

    this.weightInput.value = this.round(display);
    this.calculateWeight();
  }

  calculateWeight() {
    if (this.weightInKg == null || !this.weightLbs.length) {
      this.weightResult.textContent = '';
      return;
    }

    const lbs = Math.round(this.weightInKg / 0.453592);

    const min = this.weightLbs[0];
    const max = this.weightLbs.at(-1);

    if (lbs < min || lbs > max) {
      const minKg = min * 0.453592;
      const maxKg = max * 0.453592;

      this.weightResult.textContent =
        this.weightMode.value === 'kg'
          ? `Weight must be between ${minKg.toFixed(1)} and ${maxKg.toFixed(1)} kg`
          : `Weight must be between ${min} and ${max} lb`;

      return;
    }

    const closest = this.findClosest(this.weightLbs, lbs);
    const response = this.weightMap.get(closest);

    this.weightResult.innerHTML = this.formatText(response || '');
  }

  // ================= FORMAT =================
  formatText(text) {
    if (!text) return '';

    let safe = String(text);

    // ***text*** → <strong>text</strong>
    safe = safe.replace(
      /\*\*\*(.*?)\*\*\*/g,
      '<strong>$1</strong>'
    );

    safe = safe.replace(
      /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g,
      '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>'
    );

    safe = safe.replace(
      /(?<!href=")(https?:\/\/[^\s<]+)/g,
      '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>'
    );

    safe = safe.replace(
      /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-z]{2,})/g,
      '<a href="mailto:$1">$1</a>'
    );

    return safe
      .split(/\n{2,}/g)
      .map(block => block.trim())
      .filter(Boolean)
      .map(block =>
        `<p>${block.split('\n').map(line => `<p>${line}</p>`).join('')}</p>`
      )
      .join('');
  }

  // ================= SAVE SYSTEM =================
  initSaveInputs() {
    const wrappers = this.querySelectorAll('.baby-calculator__save-wrapper');

    wrappers.forEach(wrapper => {
      const btn = wrapper.querySelector('.baby-calculator__save-input-btn');
      const pop = wrapper.querySelector('.save-popover');
      const checkbox = wrapper.querySelector('[data-save-toggle]');
      const block = wrapper.closest('.baby-calculator__block');

      const input =
        block.querySelector('input[type="number"]') ||
        block.querySelector('input[type="text"]');

      const select = block.querySelector('select');

      const key = checkbox.dataset.saveToggle;

      const valueKey = `${key}:value`;
      const enabledKey = `${key}:enabled`;
      const selectKey = `${key}:select`;

      const enabled = localStorage.getItem(enabledKey) === 'true';
      checkbox.checked = enabled;

      if (enabled) {
        const savedValue = localStorage.getItem(valueKey);
        const savedSelect = localStorage.getItem(selectKey);

        if (select && savedSelect !== null) {
          select.value = savedSelect;
        }

        if (savedValue !== null && savedValue !== '') {
          input.value = savedValue;
        }

        if (input.dataset.ageSingle !== undefined) this.handleAgeInput();
        if (input.dataset.weightSingle !== undefined) this.handleWeightInput();
      }

      btn.addEventListener('click', e => {
        e.stopPropagation();

        const isOpen = !pop.classList.contains('hidden');

        if (isOpen) {
          pop.classList.add('hidden');
          btn.classList.remove('active');
        } else {
          this.closeAllPopovers();
          pop.classList.remove('hidden');
          btn.classList.add('active');
        }
      });

      pop.addEventListener('click', e => e.stopPropagation());

      checkbox.addEventListener('change', () => {
        localStorage.setItem(enabledKey, checkbox.checked);

        if (!checkbox.checked) {
          localStorage.removeItem(valueKey);
          localStorage.removeItem(selectKey);
          return;
        }

        this.saveState(input, select, valueKey, selectKey);
      });

      input.addEventListener('input', () => {
        if (!checkbox.checked) return;
        this.saveState(input, select, valueKey, selectKey);
      });

      if (select) {
        select.addEventListener('change', () => {
          if (!checkbox.checked) return;
          this.saveState(input, select, valueKey, selectKey);
        });
      }
    });

    document.addEventListener('click', () => this.closeAllPopovers());
  }

  saveState(input, select, valueKey, selectKey) {
    if (input.value) localStorage.setItem(valueKey, input.value);
    else localStorage.removeItem(valueKey);

    if (select) localStorage.setItem(selectKey, select.value);
  }

  closeAllPopovers() {
    this.querySelectorAll('.save-popover').forEach(p =>
      p.classList.add('hidden')
    );
    this.querySelectorAll('.baby-calculator__save-input-btn').forEach(b =>
      b.classList.remove('active')
    );
  }

  // ================= LABELS =================
  updateAgeSelectLabel() {
    if (!this.ageSelectLabel) return;
    this.ageSelectLabel.textContent =
      this.ageMode.value === 'months' ? 'mos' : 'wks';
  }

  updateWeightSelectLabel() {
    if (!this.weightSelectLabel) return;
    this.weightSelectLabel.textContent =
      this.weightMode.value === 'kg' ? 'kg' : 'lb';
  }

  // ================= UTILS =================
  findClosest(arr, target) {
    return arr.reduce((prev, curr) =>
      Math.abs(curr - target) < Math.abs(prev - target) ? curr : prev
    );
  }

  round(v) {
    return Math.round(v * 100) / 100;
  }

  clearAll() {
    const wrappers = this.querySelectorAll('.baby-calculator__save-wrapper');

    wrappers.forEach(wrapper => {
      const checkbox = wrapper.querySelector('[data-save-toggle]');
      const block = wrapper.closest('.baby-calculator__block');

      const input =
        block.querySelector('input[type="number"]') ||
        block.querySelector('input[type="text"]');

      const select = block.querySelector('select');

      const key = checkbox.dataset.saveToggle;

      const valueKey = `${key}:value`;
      const enabledKey = `${key}:enabled`;
      const selectKey = `${key}:select`;

      localStorage.removeItem(valueKey);
      localStorage.removeItem(enabledKey);
      localStorage.removeItem(selectKey);

      checkbox.checked = false;

      if (input) input.value = '';
      if (select) select.selectedIndex = 0;

      if (input?.dataset.ageSingle !== undefined) {
        this.ageInWeeks = null;
        this.ageResult.textContent = '';
      }

      if (input?.dataset.weightSingle !== undefined) {
        this.weightInKg = null;
        this.weightResult.textContent = '';
      }
    });

    this.closeAllPopovers();

    this.ageResult.textContent = '';
    this.weightResult.textContent = '';
  }
}

customElements.define('baby-calculator', BabyCalculator);